import { render, staticRenderFns } from "./AlterationApplicationsIncome.vue?vue&type=template&id=3787cb50&scoped=true&"
import script from "./AlterationApplicationsIncome.vue?vue&type=script&lang=js&"
export * from "./AlterationApplicationsIncome.vue?vue&type=script&lang=js&"
import style0 from "./AlterationApplicationsIncome.vue?vue&type=style&index=0&id=3787cb50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3787cb50",
  null
  
)

export default component.exports